import React, { Component, PureComponent, Fragment } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Popup, Icon } from 'semantic-ui-react'
import { EventLogItem } from '../event/log'
import Approval, { processApprovalInfo } from '~/project/views/editor/interview/approval'
import Tasks from '~/project/views/editor/tasks'

export function InterviewEvents({ interview }) {
  let events = interview.get('events', List())

  let popupContent = (
    <div className="coordination-event-log">
      {events.map(event => (
        <EventLogItem event={event} key={event.get('id')} />
      ))}
    </div>
  )

  return (
    <div className="coordination-status-item coordination-status-item--events">
      <Popup
        trigger={
          <button className="tags-item tags-item--grey">
            <Icon name="bell" /> {events.size}
            {events.size > 4 ? '+' : ''}
          </button>
        }
        content={popupContent}
        style={{ marginTop: 0, padding: 0, borderRadius: 0 }}
        on="click"
        position="bottom center"
      />
    </div>
  )
}

export function InterviewApprovals({ interview }) {
  let approvals = interview.get('approvals', List())

  let { activeApproval, activeApprovalId, approvalGroups, activeApprovalGroupId, activeApprovalGroup } =
    processApprovalInfo(approvals)

  let popupContent = (
    <div className="coordination-event-list">
      <Approval
        interview={interview}
        materials={interview.getIn(['data', 'materials'], List())}
        project={interview.get('project', Map())}
        items={approvals}
        approvalGroups={approvalGroups}
        activeApprovalGroupId={activeApprovalGroupId}
        activeApprovalGroup={activeApprovalGroup}
        activeApproval={activeApproval}
        activeApprovalId={activeApprovalId}
        viewOnly
      />
    </div>
  )

  let approved = approvals.filter(a => a.getIn(['data', 'status']) === 'approved').size

  return (
    <div className="coordination-status-item coordination-status-item--approvals">
      <Popup
        trigger={
          <button
            className={`tags-item tags-item--${
              approvals.size && approvals.size === approved ? 'green' : approvals.size ? 'blue' : 'grey'
            }`}>
            <Icon name="user" /> {approved}
            {' / '}
            {approvals.size}
          </button>
        }
        content={popupContent}
        style={{ marginTop: 0, padding: 0, borderRadius: 0 }}
        on="click"
        position="bottom center"
      />
    </div>
  )
}

export function InterviewTasks({ interview }) {
  let tasks = interview.get('tasks', List())
  let completed = tasks.filter(t => t.get('status') === 'completed').size
  let popupContent = (
    <div className="coordination-event-list">
      <Tasks interview={interview} project={interview.get('project', Map())} viewOnly />
    </div>
  )

  return (
    <div className="coordination-status-item coordination-status-item--tasks">
      <Popup
        trigger={
          <button className={`tags-item tags-item--${tasks.size && tasks.size === completed ? 'green' : 'grey'}`}>
            <Icon name="check" /> {completed}
            {' / '}
            {tasks.size}
          </button>
        }
        content={popupContent}
        style={{ marginTop: 0, padding: 0, borderRadius: 0 }}
        on="click"
        position="bottom center"
      />
    </div>
  )
}
